/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CloseAction from './CloseAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/MoreActions/Content/Delete/Content",
  onSubmit,
  isSubmitting
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let constantData = 'Delete image series:'
let imageSerieNameValueData = fromData.useDataValue({ viewPath,
context: 'image_serie',
path: 'name',
})
let aggregateData = fromAggregate.join(constantData, imageSerieNameValueData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let deleteSubmitData = fromData.useDataSubmit({ viewPath,
context: 'delete',
})
let deleteIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'delete',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h2"
 data="'Delete image series:'"
 data="image_serie.name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 text="Are you sure you want to delete the image series?"
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../No'))}
 type="secondary"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Cancel"
/>
)}
</TysiaButton>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="critical"
 marginLeft={dtSpaceXs}
 data="delete"
 onClick={deleteSubmitData}
 disabled={deleteIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Delete"
/>
)}
</TysiaButton>
</div>
</div>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}